import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ComplianceLabel } from "./compliance_label";
import { EditNameModal } from "./edit_name_modal";
import { useSelector } from "react-redux";
import { EditAlertModal } from "./edit_alert_modal";
import { useMoveToLeagueMutation } from "../api/courses";
import { showErrorNotification, showNotification } from "../../shared/helpers";

const ActionsColumn = ({MRLeague, actionsOpen, setActionsOpen, dropdownRef, menuRef, course, setShowNameModal, handleEditClick, canManageCustomer, hasCrs}) => {
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 })

  const handleToggle = () => {
    if (!actionsOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect()
      setMenuPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      })
    }
    setActionsOpen(!actionsOpen)
  }

  if(course.softDeleted)
    return canManageCustomer ? (
      <a href={course.unarchiveUrl} className="btsp_small_white_button">
        <i className='gga-arrow-round-right add_margin-right-5'/>
        {window.I18n.t('courses.bootstrap_archived_course_table.restore')}
      </a>
    ) : null
  else if(MRLeague)
    return(
      <div ref={dropdownRef} className={'dropMenu dropdown ' + (actionsOpen ? 'open' : '')} onClick={handleToggle}>
        <a className='btn btn-default btn-xs new_dropdown_button_icon'>
          <i className={'fa fa-lg ' + (actionsOpen ? 'fa-caret-up' : 'fa-caret-down') }/>
        </a>
        {actionsOpen && createPortal(
          <ul
            ref={menuRef}
            className='dropdown-menu'
            style={{ display: 'block', position: 'absolute', top: menuPosition.top, left: menuPosition.left, transform: 'translateX(-100%)', width: 'max-content', zIndex: 1050 }}
          >
            <li>
              <a href='#' onClick={() => { handleEditClick(); setActionsOpen(false) }}>
                <i className="gga-pencil-45-angle add-margin-right-5"/>
                {window.I18n.t('buttons.edit')}
              </a>
            </li>
            { hasCrs && course.source =='crs' &&
            <li>
              <a href={course.checkComplianceUrl}>
                <i className="gga-custom-field add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.check_compliance')}
              </a>
            </li>
            }
            <li>
              <a onClick={() => { setShowNameModal(true); setActionsOpen(false) }}>
                <i className="gga-custom-field add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.rename')}
              </a>
            </li>
            <li>
              <a href={course.archiveUrl}>
                <i className="gga-file-plus add-margin-right-5"/>
                {window.I18n.t('courses.bootstrap_course_table_data.archive')}
              </a>
            </li>
          </ul>,
          document.body
        )}
      </div>
    )
  else
    return(
    <>
      <a href='#' onClick={handleEditClick}>
        {window.I18n.t('buttons.edit')}
      </a>
    </>)
}

export const Course = ({course}) => {
  const [courseChecked, setCourseChecked] = useState(course.isChecked)
  const [actionsOpen, setActionsOpen] = useState(false)
  const [showNameModal, setShowNameModal] = useState(false)
  const dropdownRef = useRef(null)
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      const outsideTrigger = !dropdownRef.current?.contains(event.target)
      const outsideMenu = !menuRef.current?.contains(event.target)
      if (outsideTrigger && outsideMenu) {
        setActionsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])
  const [showEditModal, setShowEditModal] = useState(false)

  const MRLeague = useSelector((state) => state.misc.data.MRLeague)
  const canManageCourse = useSelector((state) => state.misc.data.canManageCourse)
  const canManageCustomer = useSelector((state) => state.misc.data.canManageCustomer)
  const isTeamCaptain = useSelector((state) => state.misc.data.isTeamCaptain)
  const hasCrs = useSelector((state) => state.misc.data.hasCrs)
  const [ moveToLeague ] = useMoveToLeagueMutation()

  const handleCheck = async () => {
    const checked = !courseChecked
    setCourseChecked(!courseChecked)

    try {
      await moveToLeague({url: course.moveToLeagueUrl, checked: checked}).unwrap()
      showNotification(window.I18n.t('courses.course_updated_successfully'))
    } catch (error) {
      setCourseChecked(courseChecked)
      showErrorNotification(window.I18n.t('courses.failed_copy_course'))
    }
}

  const handleEditClick = () => {
    setShowEditModal(!showEditModal)
  }

  return(
    <tr>
      <td className="check_col">
        { !course.softDeleted && canManageCourse &&
          <div
            className={`icheckbox_square-orange icheck-item icheck ${courseChecked ? 'checked' : ''}`}
            onClick={handleCheck}>
            <input
              type='checkbox'
              className={`i-checks icheck-input icheck ${courseChecked ? 'checked' : ''}`}
              checked={courseChecked}
            ></input>
          </div>
        }
      </td>
      <td>
        {course.name}
        {course.strokesPosition && (
          <>
            <br />
            <i>
              {!window.I18n ? '' : window.I18n.t('courses.bootstrap_course_table_data.include_tee_rotations')}
              {' '}
              {!window.I18n ? '' : window.I18n.t(
                course.strokesPosition === 'regular'
                  ? 'courses.bootstrap_course_table_data.strokes_fall_where_they_lie'
                  : 'courses.bootstrap_course_table_data.strokes_fall_evenly'
              )}
            </i>
          </>
        )}
      </td>
      <td>{course.city} {course.state}</td>
      {!gon.uses_non_whs_terminology && <td><ComplianceLabel course={course}/></td>}
      <td>{course.nameAbbreviation}</td>
      {canManageCourse && !isTeamCaptain && (
        <td className="actions">
          <ActionsColumn
            MRLeague={MRLeague}
            actionsOpen={actionsOpen}
            setActionsOpen={setActionsOpen}
            dropdownRef={dropdownRef}
            menuRef={menuRef}
            course={course}
            setShowNameModal={setShowNameModal}
            handleEditClick={handleEditClick}
            canManageCustomer={canManageCustomer}
            hasCrs={hasCrs}
          />
        </td>
      )}
      {showNameModal && <EditNameModal course={course} show={showNameModal} setShow={setShowNameModal}/>}
      {showEditModal && <EditAlertModal course={course} show={showEditModal} setShow={setShowEditModal}/>}
    </tr>
  )
}
